<template lang="pug">
//- A page's primary run-something action as one pill: the calculators'
//- orange, an icon and the label, a spinner in the icon's place while it
//- runs. Analyze by default (PCA, admixture calculators, G25); Run Oracles
//- passes its own label and icon. Disabled while busy and when the page
//- says so (offline). A user without credits can still click: the server's
//- credit gate is what opens the Add Credits dialog. Positioning stays with
//- the page's wrapper.
button.action-pill(type="button" :disabled="disabled || busy" :class="{ busy }" :aria-busy="busy ? 'true' : 'false'" @click="$emit('click', $event)")
  i.fas(:class="busy ? 'fa-circle-notch fa-spin' : icon" aria-hidden="true")
  span.action-pill-label {{ label }}
</template>

<script>
export default {
    name: 'ActionPill',
    props: {
        label: { type: String, default: 'Analyze' },
        icon: { type: String, default: 'fa-wand-magic-sparkles' },
        busy: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false }
    },
    // Declared, so a @click on the component is its event only and never
    // also falls through to the button (which would call it twice).
    emits: ['click']
}
</script>

<style>
/* The calculators' orange (App.vue's .btn-primary, #E65929) with white
   text in both themes; px-sized so it follows the UI scale. App.vue's
   phone drawer rule, which greys everything in a results drawer, exempts
   .action-pill as it does .btn. */
body .action-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    height: 28px;
    margin: 0;
    padding: 0 14px;
    border-radius: 14px;
    border: 1px solid #E65929;
    background: #E65929;
    color: #fff;
    font-family: Inter, sans-serif;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.2px;
    text-transform: none;
    white-space: nowrap;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
    transition: filter 0.15s ease;
}
body .action-pill i {
    font-size: 12px;
    color: inherit;
}
body .action-pill:hover:not(:disabled) {
    filter: brightness(1.08);
}
body .action-pill:focus-visible {
    outline: 2px solid rgba(230, 89, 41, 0.45);
    outline-offset: 2px;
}
body .action-pill:disabled {
    opacity: 0.6;
    cursor: default;
}
body .action-pill.busy:disabled {
    opacity: 0.85;
}
</style>
